export const truncateText = (value, maxLength = 50) => {
  const text = String(value || "");
  const characters = Array.from(text);

  return characters.length > maxLength
    ? `${characters.slice(0, maxLength).join("")}…`
    : text;
};

export const formatProjectValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  const amount = Number(value);

  if (!Number.isFinite(amount)) {
    return "-";
  }

  return new Intl.NumberFormat("en-MY", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
};
